import type { JSONContent } from '@tiptap/core'
import type { ChatStatus, MessagesAttachmentMmsFile } from '@/data/models/domain/chats/types'
import type AttachmentFile from '@/data/models/domain/attachmentFile/AttachmentFile'

export interface ChatAssignFormScheme {
  assigneeId: string
}

export interface ChatRejectFormScheme {
  reason: string
  blockByIp: boolean
  blockContact: boolean
}

export enum ChatExtraFilterName {
  Status = 'status',
  Assignee = 'assignee',
  Tags = 'tags',
  ContactTags = 'contactTags',
  Channel = 'channel',
  Rating = 'rating',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  CreatedAt = 'createdAt',
  Unread = 'unread',
  ChatType = 'chatType',
  LastMessageSource = 'lastMessageSource',
}

export enum ChatFilterRatingType {
  GOOD = 'good',
  POOR = 'poor',
  NO_RATE = 'no-rate',
}

export interface IChatUpdateByFiltersParams {
  id: unknown
  status: { in?: ChatStatus[]; notIn?: ChatStatus[] }
  chatType: unknown
  channel: { in: { type: string; value: string }[] }
  assignee: { in: string[] }
  tags: { in: string[] }
  contactTags: { in: string[] }
  createdAt: string
  updatedBy: string
  updatedAt: string
  unread: number
  default: unknown
  searchQuery: string
  rating: { in: ChatFilterRatingType[] }
  lastMessageSource: string
}

export type ChatUpdateByFiltersParams = Partial<IChatUpdateByFiltersParams>[]

export type ChatStatisticsNotificationParams = {
  id: string
  chatId: string
  title?: string
  icon?: string
}
export const ChannelChatFilterKey = 'channelChatFilter'

export enum ChatFilterViewFixedName {
  Open = 'open',
  Unread = 'unread',
  AssignedToMe = 'assignedToMe',
  Unassigned = 'unassigned',
  WaitingLiveChats = 'waitingLiveChats',
  Solved = 'solved',
  All = 'allChats',
}

export const chatNavigationDefaultOrder = [
  ChatFilterViewFixedName.Open,
  ChatFilterViewFixedName.Unread,
  ChatFilterViewFixedName.AssignedToMe,
  ChatFilterViewFixedName.Unassigned,
  ChatFilterViewFixedName.WaitingLiveChats,
  ChatFilterViewFixedName.Solved,
  ChatFilterViewFixedName.All,
] as const

export type ChatNavigationOrderKey = (typeof chatNavigationDefaultOrder)[number]

export const chatNavigationOrderApiKey: Record<ChatNavigationOrderKey, string> = {
  [ChatFilterViewFixedName.Open]: 'open',
  [ChatFilterViewFixedName.Unread]: 'unread',
  [ChatFilterViewFixedName.AssignedToMe]: 'assigned',
  [ChatFilterViewFixedName.Unassigned]: 'unassigned',
  [ChatFilterViewFixedName.WaitingLiveChats]: 'waitingLiveChats',
  [ChatFilterViewFixedName.Solved]: 'solved',
  [ChatFilterViewFixedName.All]: 'all',
}

export interface ChatMessageSavedContentData {
  content: JSONContent
  file?: MessagesAttachmentMmsFile
  attachmentFiles: AttachmentFile[]
}
